import React, { useEffect } from 'react';
import { get } from 'lodash';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import AdNewFormDescriptions from '../../Ads/AdNewForm/AdNewFormDescriptions';
import LoaderButton from '../../LoaderButton/LoaderButton';
import { FETCH_CHANNEL_ACTIVATION } from '../../../redux/ChannelActivations';
import { FETCH_PROMOTION, UPDATE_PROMOTION } from '../../../redux/Promotions';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const MobileUpdateForm = ({ t, maxHighlights, isLoading, channelName, fetchPromotion, fetchChannelActivation,
                            promotionData, updatePromotion, match: { params: { promotionId, }, }, }) => {
  const claesses = useStyles();
  useEffect(() => {
    fetchPromotion(promotionId);
    if (channelName) {
      fetchChannelActivation(channelName);
    }
  }, [fetchPromotion, channelName]);
  const highlights = promotionData.highlights?.map((item, index) => ([[`highlight_${index + 1}`], item]));

  const initialValues = (({ description, }) => (
      { description, ...Object.fromEntries(highlights || []), }))(promotionData);
  return (
    <div>
      {promotionData.id &&
        <Form
          onSubmit={(values) => updatePromotion({ values, promotionId: promotionData.id, })}
          initialValues={initialValues}
          render={({ handleSubmit, }) => (
            <form onSubmit={handleSubmit} className={claesses.form}>
              <h2 className={claesses.title}>{t('descriptions')}</h2>
              <AdNewFormDescriptions
                formType="react-final-form"
                numberOfHighlights={maxHighlights}
              />
              <div>
                <LoaderButton
                  className={claesses.submitButton}
                  isLoading={isLoading}
                  label={t('submit')}
                />
              </div>
            </form>
          )}
        />
      }
    </div>
  );
};

const useStyles = createUseStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 30,
    paddingTop: 8,
    paddingRight: 15,
    paddingBottom: 8,
    paddingLeft: 15,
    fontSize: 20,
    fontWeight: 700,
    color: '#6c6473',
    backgroundColor: '#f7f7f7',
  },
  submitButton: {
    marginBottom: 30,
    marginLeft: 15,
  },
});

MobileUpdateForm.propTypes = {
  t: PropTypes.func.isRequired,
  maxHighlights: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  fetchPromotion: PropTypes.func.isRequired,
  fetchChannelActivation: PropTypes.func.isRequired,
  updatePromotion: PropTypes.func.isRequired,
  channelName: PropTypes.string,
  promotionData: PropTypes.object,
};

MobileUpdateForm.defaultProps = {
  promotionData: {},
  channelName: '',
};

const mapStateToProps = (state) => {
  return {
    maxHighlights: get(state, ['channelActivations', 'channel_activation_data', 'max_highlights']),
    promotionData: get(state, ['promotions', 'data']),
    channelName: get(state, ['promotions', 'data', 'channel_name']),
    isLoading: get(state, ['loader', 'isLoading']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPromotion: (id) => dispatch(FETCH_PROMOTION(id)),
    fetchChannelActivation: (channel) => dispatch(FETCH_CHANNEL_ACTIVATION(channel)),
    updatePromotion: (params) => dispatch(UPDATE_PROMOTION(params)),
  };
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('ad_vehicle_description'),
  withRouter
  )(MobileUpdateForm);
